import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { ActionCreators } from './+state/workflow.actions';
import { requestCompleted } from '@certemy/common';
import { Selectors } from './+state/workflow.state';
import { WORKFLOW_MODULE_ID } from 'constants/workflow.constants';
import { CREDENTIAL_TYPES } from 'components/organization-certification/organization-certification.constants';
import _get from 'lodash-es/get';
import { updateRouteBreadcrumb } from 'utils/helpers';

@Injectable()
export class WorkflowDetailsGuardService  {
  constructor(private store: Store<any>) {}

  canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot): Observable<boolean> {
    let { workflowTypeId, workflowId } = activatedRouteSnapshot.params;
    workflowTypeId = parseInt(workflowTypeId, 10);
    workflowId = workflowId && parseInt(workflowId, 10);
    const workflowSubTypeId = (workflowTypeId === WORKFLOW_MODULE_ID.TESTING_WORKFLOW
      ? CREDENTIAL_TYPES.TESTING.id
      : null) as number;

    this.store.dispatch(new ActionCreators.GetWorkflowDetailsData({ workflowTypeId, workflowId, workflowSubTypeId }));

    return requestCompleted(this.store.select(Selectors.workflowState));
  }
}

export const workflowDetailsGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
  return inject(WorkflowDetailsGuardService).canActivate(route);
};

@Injectable()
export class WorkflowGuardService  {
  constructor(private router: Router) {}

  canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot): Observable<boolean> {
    const { workflowTypeId } = activatedRouteSnapshot.params;

    if (isNaN(workflowTypeId) || !WORKFLOW_MODULE_ID[workflowTypeId]) {
      this.router.navigateByUrl('/');
      return of(false);
    }
    switch (Number(_get(activatedRouteSnapshot.params, 'workflowTypeId', WORKFLOW_MODULE_ID.TESTING_WORKFLOW))) {
      case WORKFLOW_MODULE_ID.COMPLIANCE:
        delete activatedRouteSnapshot.routeConfig.data.breadcrumb;
        break;
      default:
        updateRouteBreadcrumb(activatedRouteSnapshot, 'Testing Workflow');
        break;
    }
    return of(true);
  }
}

export const workflowGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
  return inject(WorkflowGuardService).canActivate(route);
};
